




































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { storePenunjang } from "@/store/modules/penunjang";
import _, { isEmpty } from "lodash";

@Component({})
export default class CardModalItemPenunjang extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() orderItems: Array<object> = [];
  @Prop() groupList = [];

  searchQuery = "";
  selected = [];
  checkedItems = this.orderItems;
  get show() {
    return this.value;
  }
  set show(value) {
    this.searchQuery = "";
    this.$emit("input", value);
  }
  // get checkedItems() {
  //   return this.orderItems;
  // }
  @Watch("orderItems")
  changed(val) {
    this.checkedItems = val;
    // console.log("val", val);
  }
  mounted() {
    // this.checkedItems= this.orderItems
    // this.stateGroup()
  }
  getItem() {
    this.show = false;
    this.$emit("set-order-items", this.checkedItems);
  }
  cancel() {
    this.orderItems = [];
    console.log(this.checkedItems);
    this.show = false;
  }
  get statepenunjanggroup() {
    return storePenunjang.penunjangGroupLab;
  }
  stateGroup() {
    storePenunjang.act_item_group_lab();
  }
  get filteredItems() {
    return _.compact(
      this.groupList.map(a => {
        const items = a.items.filter(sub => {
          return sub.name
            .toLowerCase()
            .includes(this.searchQuery.trim().toLowerCase());
        });
        return items.length > 0
          ? {
              id: a.id,
              name: a.name,
              items: items
            }
          : null;
      })
    );
  }
  get textCheckedItems() {
    return _.join(_.map(this.checkedItems, "name"), ", ");
  }
}
